export enum QueryKey {
  PORTFOLIOS = "PORTFOLIOS",
  PORTFOLIO = "PORTFOLIO",
  ACCOUNT = "ACCOUNT",
  ACCOUNT_SLIM = "ACCOUNT_SLIM",
  AVAILABLE_TAGS = "AVAILABLE_TAGS",
  ALERT_SUBSCRIPTION = "ALERT_SUBSCRIPTION",
  CUSTOM_GEOJSON_FILE = "CUSTOM_GEOJSON_FILE",
  CUSTOM_GEOJSON_LIST = "CUSTOM_GEOJSON_LIST",
  CUSTOM_GEOJSON_SIZE = "CUSTOM_GEOJSON_SIZE",
  CUSTOM_GEOJSON_UPLOAD = "CUSTOM_GEOJSON_UPLOAD",
  CUSTOM_COLORMAP_LIST = "CUSTOM_COLORMAP_LIST",
  CUSTOM_COLORMAP = "CUSTOM_COLORMAP",
  COLORMAP_STEPS = "COLORMAP_STEPS",
  FILE_STORAGE_INFO = "FILE_STORAGE_INFO",
  LAYER = "LAYER",
  MARKETPLACE_ASSET = "MARKETPLACE_ASSET",
  MARKETPLACE_DASHBOARDS = "MARKETPLACE_DASHBOARDS",
  MARKETPLACE_DASHBOARD = "MARKETPLACE_DASHBOARD",
  MULTI_LOCATION_TABLE = "MULTI_LOCATION_TABLE",
  POLYGON_TABLE = "POLYGON_TABLE",
  PLOT_CUSTOM_OPTION = "PLOT_CUSTOM_OPTION",
  POPUP_CROSS_SECTION = "POPUP_CROSS_SECTION",
  PROFILE = "PROFILE",
  PROFILE_INFO = "PROFILE_INFO",
  PROFILES = "PROFILES",
  TAB = "TAB",
  TIME_STATE = "TIME_STATE",
  UK_FLOODS = "UK_FLOODS",
  USER = "USER",
}
